import { ChangeEvent, useState, useEffect } from "react";
import Box from "@mui/material/Box";
import FormLayout from "../../../components/FormLayout";
import CommonCard from "./CommonCard";
import { Typography } from "@mui/material";
import RadioQuestions from "../../../components/RadioQuestions";
import TextInput from "../../../components/TextInput";
import { toDollar } from "../../../utils/dataConverter";
import { useRefund } from "../../../hooks/TaxCalculations";
import { useDispatch, useSelector } from "react-redux";
import { paymentSlice } from "../../../store/reducer/payment";
import { TaxCalculations } from "../../../model/tax_calculations";
import { UserChoice } from "../../../model/final_balance/user_choice";
import { Refund } from "../../../model/final_balance/refund";
import { RefundType } from "../../../model/final_balance/refund_types";
import CustomButton from "../../../components/CustomButton";
import { goBack, push } from "redux-first-history";

interface RefundProps {
  finalBalance: number,
  taxBreakdown: TaxCalculations,
}

export default function BalanceRefund({
  finalBalance,
  taxBreakdown,
}: RefundProps) {
  const {
    data: { collection_year },
  } = useSelector((appState: any) => appState.user);
  // TODO may want to dispatch fetchRefund action
  const refund: Refund = useRefund();

  // TODO set these from redux store
  // TODO changeRefund if balance is negative prior to this?
  const [refundAmount, setRefundAmount] = useState(refund.refund_amount);
  const [creditAmount, setCreditAmount] = useState(refund.credit_amount);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(paymentSlice.actions.changeRefund({
      refundAmount: refundAmount,
      creditAmount: creditAmount
    }));
  }, [refundAmount, creditAmount, dispatch]);

  const summary = {
    title: ` Result`,
    cardDescription: "",
    options: {
      "Springboro Tax": taxBreakdown.tax_liability,
      "Total Credits": taxBreakdown.total_credits,
      Overpayment: Math.abs(finalBalance),
    },
  };

  return (
    <FormLayout
      title={"Refund Owed"}
      subtitle={"Review Balance"}
      description={
        "You don’t owe us any tax; in fact, you paid more tax than you owe Springboro this year."
      }
      className=""
    >
      <Box className='card'>
        <CommonCard cardDetails={summary} />
      </Box>
      <span>
        Next, you'll sign your return, and then decide whether you want a refund of your overpayment or whether you prefer to apply some/all of the overpayment to next year's return.
      </span>
      <div className='btn-container'>
        <CustomButton
          variant="outlined"
          disableElevation={false}
          label={"back"}
          onClick={() => dispatch(goBack())}
          buttonSize='btn-lg'
        />
        <CustomButton
          variant="contained"
          disableElevation={true}
          label={"next"}
          onClick={() => dispatch(push('/balance/sign')) }
          buttonSize="btn-lg"
        />
      </div>
    </FormLayout>
  );
}